import { NumberFormat, type NumberFormatProps } from '../number';

/**
 * style is omitted from Intl.NumberFormatOptions and renamed to formatStyle to prevent a clash with the
 * BaseHTMLAttributes "style" (which would be the CSS style object)
 */
export interface CurrencyFormatProps extends Omit<NumberFormatProps, 'formatStyle'> {
  currency?: string;
}

export function CurrencyFormat({ currency = 'USD', ...rest }: CurrencyFormatProps) {
  return <NumberFormat {...rest} currency={currency} data-currency={currency} formatStyle="currency" />;
}
